import { useState } from 'react'
import { projectsData } from './Data'
import ProjectCard from './ProjectCard'

const Works = () => {
  // const [item, setItem] = useState({ name: 'all' })
  const [projects, setProjects] = useState([projectsData])
  // const [active, setActive] = useState(0)

  // const handleClick = (e, index) => {
  //   setItem({ name: e.target.textContent })
  //   setActive(index)
  // }

  return (
    <>
      {/* <div className='work__filters'>
        {projectsNav.map((item, index) => {
          return (
            <span
              key={index}
              className={`${active === index ? 'active-work' : ''} work__item`}
              onClick={(e) => {
                handleClick(e, index)
              }}>
              {item.name}
            </span>
          )
        })}
      </div> */}
      <div className='work__container container grid'>
        {projectsData.map((item) => {
          return <ProjectCard item={item} key={item.id} />
        })}
      </div>
    </>
  )
}
export default Works
